import styled from "styled-components";
export const Content = styled.div` width: 100%;
display: flex;
flex-wrap: wrap;
gap: 20px;
.form-group {
  display: flex;
  flex-direction: column;
  span {
    font-size: 16px;
    margin-bottom: 5px;
    font-weight: 500;
  }
}
`;
